import { useCallback, useState } from "react";

export function useCounter(init = 0) {
    const [counter, setCounter] = useState(init);
    const inc = useCallback(() => { setCounter(x => x + 1) }, [setCounter]);
    return [counter, inc, setCounter];
}